import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

const selectState = (state: RootState) => state.dashboard;

export const selectIsEditMode = createSelector(selectState, ({ isEditMode }) => isEditMode);
export const selectDateRange = createSelector(selectState, ({ dateRange }) => dateRange);
